import {startTransition, useContext, useEffect} from "react";
import {matchRoutes, useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import AppContext, {SidebarType} from "../../context/AppContext";
import NotificationContext from "../../context/NotificationContext";
import InLayer from "../general/InLayer";
import {joinPath, readJoinTicket} from "../../lib/joinTicket";

export default (props: { onBack: () => void }) => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  // RISKS.md/P2.79: the address first, since the green room stores its ticket only at the join.
  // matchRoutes, not matchPath: only the former decodes the address as the routes do.
  const ticket = matchRoutes([{path: '/join/:token'}], useLocation())?.[0].params.token ?? readJoinTicket()

  const {ws, setSidebar} = useContext(AppContext)
  const {clearNotifications} = useContext(NotificationContext)

  // RISKS.md/P2.77: not left to App's unmount cleanup, which never runs when App fails before its
  // first commit: the socket would stay open and our media published behind this notice. The
  // sidebar closes because the provider keeps it across the rejoin, where a panel that failed would
  // open and fail again. At mount only: clearNotifications is a new function at every render, and
  // calling it renders again.
  useEffect(() => {
    ws?.disconnect()
    clearNotifications()
    setSidebar(SidebarType.None)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <InLayer
      title={t('chat.sessionFailed.title')}
      // One transition: react-router navigates in one, so a reset outside it would first render the
      // failed route again, at the old address.
      onConfirm={() => startTransition(() => {
        navigate(ticket ? joinPath(ticket) : '/meeting', { replace: true })
        props.onBack()
      })}
    >
      {t('chat.sessionFailed.message')}
    </InLayer>
  )
}
